<template>
    <div class="service-details ptb-100">
        <div class="container">
            <div class="service-details-content">
                <h3 data-aos="fade-up" data-aos-once="true">Gefunden werden, wenn es darauf ankommt</h3>

                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Eine schöne Webseite bringt wenig, wenn sie niemand findet. Suchmaschinenoptimierung (SEO) sorgt dafür, dass potenzielle Kunden Sie genau dann finden, wenn sie nach Ihren Leistungen suchen. Wir analysieren Ihre Webseite und entwickeln eine Strategie, die nachhaltig wirkt.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-once="true" data-aos-delay="0">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-analyse'></i>
                            </div>
                            <h3>SEO-Analyse</h3>
                            <p>Umfassende Prüfung Ihrer aktuellen Webseite. Technische Probleme, Content-Qualität und Optimierungspotenziale werden identifiziert.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-once="true" data-aos-delay="100">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-key'></i>
                            </div>
                            <h3>Keyword-Recherche</h3>
                            <p>Welche Begriffe suchen Ihre potenziellen Kunden? Wir finden die relevanten Keywords für Ihre Branche.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-once="true" data-aos-delay="200">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-cog'></i>
                            </div>
                            <h3>Technisches SEO</h3>
                            <p>Ladezeit, Mobile-Optimierung, Seitenstruktur - alle technischen Faktoren werden optimiert.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-once="true" data-aos-delay="300">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-file'></i>
                            </div>
                            <h3>Content-Optimierung</h3>
                            <p>Texte, Überschriften und Meta-Daten werden für Suchmaschinen und Besucher optimiert.</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Was SEO für Ihr Unternehmen bedeutet</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Stellen Sie sich vor, ein potenzieller Kunde sucht nach genau der Dienstleistung, die Sie anbieten. Mit guter SEO erscheint Ihre Webseite auf der ersten Seite bei Google - dort, wo 90% aller Klicks passieren. Ohne SEO verlieren Sie täglich potenzielle Kunden an Ihre Konkurrenz.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="0">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-search'></i>
                            <h3>93%</h3>
                            <p>aller Online-Erfahrungen beginnen mit einer Suchmaschine</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="100">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-pointer'></i>
                            <h3>75%</h3>
                            <p>der Nutzer scrollen nicht über die erste Seite hinaus</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="200">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-trending-up'></i>
                            <h3>14.6%</h3>
                            <p>Conversion-Rate bei SEO-Leads vs. 1.7% bei Outbound</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Mein SEO-Ansatz</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">SEO ist kein einmaliges Projekt, sondern ein kontinuierlicher Prozess. Wir bieten sowohl einmalige SEO-Audits als auch langfristige Betreuung an:</p>

                <ul class="features-list" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <li><i class='bx bx-check'></i> <strong>SEO-Audit</strong> - Einmalige Analyse mit konkreten Handlungsempfehlungen</li>
                    <li><i class='bx bx-check'></i> <strong>On-Page Optimierung</strong> - Technische und inhaltliche Verbesserungen direkt auf Ihrer Seite</li>
                    <li><i class='bx bx-check'></i> <strong>Local SEO</strong> - Wichtig für lokale Unternehmen: Google Maps, Branchenverzeichnisse</li>
                    <li><i class='bx bx-check'></i> <strong>Monatliche Reports</strong> - Transparente Auswertungen über Rankings und Traffic</li>
                    <li><i class='bx bx-check'></i> <strong>Nachhaltige Strategien</strong> - Keine Black-Hat-Methoden, die Google abstraft</li>
                </ul>

                <h4 data-aos="fade-up" data-aos-once="true">Ehrlichkeit bei SEO</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Wir versprechen Ihnen keine garantierten Rankings - das kann niemand seriös tun. Was wir Ihnen bieten: transparente Arbeit, messbare Verbesserungen und realistische Einschätzungen. SEO braucht Zeit, aber die Investition zahlt sich langfristig aus.</p>

                <div class="pricing-box mt-5" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <div class="single-pricing-table">
                        <div class="pricing-header">
                            <h3>SEO-Paket</h3>
                        </div>

                        <div class="price">
                            <span class="price-text">Nach Vereinbarung</span>
                        </div>

                        <p class="pricing-description">In einem kostenlosen Erstgespräch schaue ich mir Ihre aktuelle Situation an und zeige Ihnen, wo Potenzial liegt.</p>

                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Keyword-Recherche</li>
                            <li><i class='bx bxs-badge-check'></i> On-Page-Optimierung</li>
                            <li><i class='bx bxs-badge-check'></i> Technisches SEO-Audit</li>
                            <li><i class='bx bxs-badge-check'></i> Content-Optimierung</li>
                            <li><i class='bx bxs-badge-check'></i> Monatliche Reports</li>
                            <li><i class='bx bxs-badge-check'></i> Nachhaltige Strategien</li>
                        </ul>

                        <div class="btn-box">
                            <router-link to="/contact" class="default-btn">
                                <i class='bx bxs-paper-plane'></i>
                                Kostenlose SEO-Ersteinschätzung
                                <span></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SeoDetails'
}
</script>

<style scoped>
.pricing-box {
    max-width: 450px;
    margin: 0 auto;
}

.pricing-box .single-pricing-table {
    background: #ffffff;
    border-radius: 10px;
    padding: 40px 30px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.pricing-box .pricing-header h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #080a3c;
}

.pricing-box .price {
    margin-bottom: 25px;
}

.pricing-box .price-text {
    font-size: 28px;
    font-weight: 700;
    color: #010215;
}

.pricing-box .pricing-description {
    color: #4a6f8a;
    margin-bottom: 25px;
    font-size: 15px;
}

.pricing-box .pricing-features {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
    text-align: left;
}

.pricing-box .pricing-features li {
    padding: 12px 0 !important;
    padding-left: 0 !important;
    border-bottom: 1px solid #eee;
    color: #4a6f8a;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 12px;
    position: static !important;
}

.pricing-box .pricing-features li:last-child {
    border-bottom: none;
}

.pricing-box .pricing-features li i {
    color: #010215;
    font-size: 18px;
    flex-shrink: 0;
    position: static !important;
}

.pricing-box .btn-box {
    text-align: center;
}
</style>
